var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BjDrawerForm",
    {
      ref: "BjDrawerForm",
      staticClass: "view-container",
      attrs: { form: _vm.form, "label-width": "130px", width: "850px" },
      on: { handleConfirm: _vm.handleConfirm },
    },
    [
      [
        _c(
          "BjDivider",
          {
            scopedSlots: _vm._u(
              [
                _vm.isEdit
                  ? {
                      key: "right",
                      fn: function () {
                        return [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.showLog },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "BusinessPurchaseSupplierShop.dataForm.titleBtn"
                                  )
                                )
                              ),
                            ]
                          ),
                        ]
                      },
                      proxy: true,
                    }
                  : null,
              ],
              null,
              true
            ),
          },
          [
            _vm._v(
              _vm._s(_vm.$t("BusinessPurchaseSupplierShop.dataForm.title")) +
                " "
            ),
          ]
        ),
        _c(
          "el-row",
          [
            _c(
              "el-col",
              { attrs: { span: 12 } },
              [
                _c("BjFormItemCode", {
                  attrs: {
                    disabled: "",
                    label: _vm.$t("ChannelManagement.Main.code"),
                  },
                  model: {
                    value: _vm.channelData.code,
                    callback: function ($$v) {
                      _vm.$set(_vm.channelData, "code", $$v)
                    },
                    expression: "channelData.code",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-col",
              { attrs: { span: 12 } },
              [
                _c("BjFormItemCode", {
                  attrs: {
                    disabled: "",
                    label: _vm.$t("ChannelManagement.Main.name"),
                  },
                  model: {
                    value: _vm.channelData.name,
                    callback: function ($$v) {
                      _vm.$set(_vm.channelData, "name", $$v)
                    },
                    expression: "channelData.name",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "BjDivider",
          {
            scopedSlots: _vm._u([
              {
                key: "right",
                fn: function () {
                  return [
                    !_vm.isEdit
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.addGoodsDialog },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "BusinessPurchaseSupplierShop.dataForm.addCommodity"
                                )
                              )
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                },
                proxy: true,
              },
            ]),
          },
          [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "BusinessPurchaseSupplierShop.dataForm.productInformation"
                )
              ) + " "
            ),
          ]
        ),
        _c(
          "el-table",
          { attrs: { data: _vm.form.skuList, border: "", script: "" } },
          [
            _c("el-table-column", {
              attrs: {
                type: "index",
                label: _vm.$t("table.countText"),
                width: "60",
                align: "center",
              },
            }),
            _c("el-table-column", {
              attrs: {
                prop: "innerSkuCode",
                label: _vm.$t("BusinessPurchaseSupplierShop.dataForm.sku"),
                align: "center",
              },
            }),
            _c("el-table-column", {
              attrs: {
                prop: "skuCode",
                label: _vm.$t("ChannelManagement.Main.innerSkuCode"),
                align: "center",
                width: "145",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (ref) {
                    var row = ref.row
                    return [
                      !_vm.isEdit
                        ? _c("BjInputCode", {
                            attrs: {
                              disabled: _vm.isEdit,
                              maxlength: _vm.MAX_LENGTH.DEFAULT,
                              placeholder: _vm.$t("inputText"),
                              clearable: "",
                            },
                            model: {
                              value: row.skuCode,
                              callback: function ($$v) {
                                _vm.$set(row, "skuCode", $$v)
                              },
                              expression: "row.skuCode",
                            },
                          })
                        : [_vm._v(_vm._s(row.skuCode))],
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                prop: "price",
                label: _vm.$t("ChannelManagement.Main.price"),
                align: "center",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (ref) {
                    var row = ref.row
                    return [
                      _c("BjInputMoney", {
                        attrs: {
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                        },
                        model: {
                          value: row.price,
                          callback: function ($$v) {
                            _vm.$set(row, "price", $$v)
                          },
                          expression: "row.price",
                        },
                      }),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                prop: "newPrice",
                label: _vm.$t("ChannelManagement.Main.newPrice"),
                align: "center",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (ref) {
                    var row = ref.row
                    return [
                      _c("BjInputMoney", {
                        attrs: {
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                        },
                        model: {
                          value: row.newPrice,
                          callback: function ($$v) {
                            _vm.$set(row, "newPrice", $$v)
                          },
                          expression: "row.newPrice",
                        },
                      }),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                prop: "updatePriceTime",
                label: _vm.$t("ChannelManagement.Main.updatePriceTime"),
                align: "center",
                width: "175",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (ref) {
                    var row = ref.row
                    return [
                      _c("el-date-picker", {
                        staticClass: "full-width",
                        attrs: {
                          type: "date",
                          "picker-options": _vm.pickerOptions,
                          format: "dd/MM/yyyy",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          placeholder: _vm.$t("chooseText"),
                        },
                        model: {
                          value: row.updatePriceTime,
                          callback: function ($$v) {
                            _vm.$set(row, "updatePriceTime", $$v)
                          },
                          expression: "row.updatePriceTime",
                        },
                      }),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _c("BjDialogList", {
          ref: "dialogListSku",
          attrs: {
            width: "80%",
            config: _vm.$BjDialogListConfig.skuDefault(
              this.$t("BusinessPurchaseSupplierShop.dataForm.addCommodity"),
              { defaultQuery: { setFlag: 0, status: [3, 4, 5] } }
            ),
            multiple: "",
          },
          on: { confirm: _vm.onAddGoodsDialogConfirm },
        }),
      ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }